module.exports = __webpack_public_path__ + "static/media/Contracts.b9e76950.png";